import { render, staticRenderFns } from "./Guess.vue?vue&type=template&id=9f5d7e22&scoped=true&"
import script from "./Guess.vue?vue&type=script&lang=js&"
export * from "./Guess.vue?vue&type=script&lang=js&"
import style0 from "./Guess.vue?vue&type=style&index=0&id=9f5d7e22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5d7e22",
  null
  
)

export default component.exports